import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedFormPipesModule } from '@sondermind/iris/form-helpers';

import { IrisCheckboxComponent } from './checkbox.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedFormPipesModule
  ],
  declarations: [
    IrisCheckboxComponent
  ],
  exports: [
    IrisCheckboxComponent
  ]
})

export class IrisCheckboxModule {}
